import React from 'react';
import { Form, Input } from 'antd';

import GenericForm, { Props as GenericFormProps } from 'routes/generic/form';

type Props = Omit<GenericFormProps, 'renderFields'>;

const { TextArea } = Input;

const EditForm: React.FC<Props> = props => {
  return (
    <GenericForm
      {...props}
      renderFields={() => (
        <>
          <Form.Item required label="Label" name="label">
            <Input className="monospace" />
          </Form.Item>
          <Form.Item required label="Explanation" name="explanation">
            <TextArea className="monospace" autoSize />
          </Form.Item>
        </>
      )}
    />
  );
};

export default EditForm;
